import React from "react";

const OpportunityCard = ({ title, Imgsrc }) => {
  return (
    <div className="opportunityCard">
      <div className="opportunityCardImage">
        <img src={Imgsrc} alt={title} />
      </div>
      <div className="opportunityCardTitle">
        <span>{title}</span>
      </div>
    </div>
  );
};

export default OpportunityCard;
